module.exports = "../../../../platform/assets/pageMainIcon/yewushezhilei5.svg";